function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBtnGnbBack = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uC0AC\\uAC01\\uD615 71",
  style: {
    fill: "none"
  },
  d: "M0 0h36v36H0z"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "\\uADF8\\uB8F9 1"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 1",
  d: "m1986.887 175.484-8 8 8 8",
  transform: "translate(-1970.887 -165.482)",
  style: {
    strokeLinejoin: "round",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 2",
  d: "M1981 175.4h20",
  transform: "translate(-1972 -157.397)",
  style: {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none"
  }
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBtnGnbBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "700327c78b7e4f6dfff7c174877e7f29.svg";